import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

const messages: {
	[key: string]: MessageDescriptor;
} = defineMessages({
	tooltip: {
		id: 'issue-create-commons.create-work-video-education-modal-trigger-button.tooltip',
		defaultMessage: 'Watch a tutorial on how to create work',
		description: 'Tooltip for create work video education modal trigger button',
	},
	openVideoModalButtonLabel: {
		id: 'issue-create-commons.create-work-video-education-modal-trigger-button.open-video-modal-button-label',
		defaultMessage: 'Introduction to work items',
		description: 'Label for create work item video education modal trigger button',
	},
	videoIconLabel: {
		id: 'issue-create-commons.create-work-video-education-modal-trigger-button.video-icon-label',
		defaultMessage: 'Video',
		description: 'Label for video icon in the banner',
	},
	closeBannerLabel: {
		id: 'issue-create-commons.create-work-video-education-modal-trigger-button.close-banner-label',
		defaultMessage: 'Close',
		description: 'Label for close button in the banner',
	},
});

export default messages;
